import { FC } from "react";
import regularTicketIcon from "./icons/ticket-grey.png";
import rareTicketIcon from "./icons/ticket-blue.png";
import epicTicketIcon from "./icons/ticket-purple.png";
import legendaryTicketIcon from "./icons/ticket-yellow.png";
import styles from "./Ticket.module.scss";
import { Tooltip } from "@mui/material";

export enum TicketType {
    Regular = 'regularTickets',
    Rare = 'rareTickets',
    Epic = 'epicTickets',
    Legendary = 'legendaryTickets',
}

export type TicketsPanelContext =
    'header' | 'work-button' | 'wheel-prize' | 'referal' | 'description' | 'draw-button' | 'bonus' | 'balance-error' | 'modal' | 'small' | '';

interface ITicketProps {
    type: TicketType,
    value: number;
    prefix?: string;
    postfix?: string;
    context?: TicketsPanelContext;
    precission?: number;
    hideValue?: boolean;
    tooltip?: string;
}

export const Ticket: FC<ITicketProps> = ({ value, type, context = '', prefix = '', postfix = '', precission, hideValue = false, tooltip }) => {
    const getIcon = () => {
        switch (type) {
            case TicketType.Regular: return regularTicketIcon;
            case TicketType.Rare: return rareTicketIcon;
            case TicketType.Epic: return epicTicketIcon;
            case TicketType.Legendary: return legendaryTicketIcon;
        }
    }

    const getTicket = () => {        
        if (precission === undefined) {
            precission = 2;

            if (value >= 100)
                precission = Math.min(0, precission);
            else if (value >= 10)
                precission = Math.min(1, precission);
        }
        
        return (
            <div className={`${styles.ticketItem} ${styles[context]}`}>
                <img alt="ticket" className={ `${styles.ticketImage} ${styles[context]} ${styles[type]}` } src={ getIcon() } />
                <span className={ `${styles.ticketText} ${styles[context]}`}>{`${prefix}${hideValue ? '' : value?.toFixed(precission)}${postfix}`}</span>
            </div>
        );
    }

    const getTooltip = () => {
        return (
            <Tooltip 
                title={tooltip}
                arrow
                enterTouchDelay={0}
                leaveTouchDelay={4000}
                classes={{
                    tooltip: `${styles.tooltip} ${styles.body}`,
                    arrow: `${styles.tooltip} ${styles.arrow}`,
                }}
                slotProps={{
                    popper: {
                    modifiers: [
                        {
                        name: 'offset',
                        options: {
                            offset: [0, -14],
                        },
                        },
                    ],
                    },
                }}
            >
                { getTicket() }
            </Tooltip>
        );
    }

    return (
        <>
            { tooltip ? getTooltip() : getTicket() }
        </>
    );
}

